import { render } from "./ChatsActivosView.vue?vue&type=template&id=33c4fdae&ts=true"
import script from "./ChatsActivosView.vue?vue&type=script&lang=ts"
export * from "./ChatsActivosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__